import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_field_for_generation_layout } from '@/state/ui/image/LOCAL__ui_set_field_for_generation_layout';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { ENUM__page_generation_layout } from '../_enums/ENUM__page_generation_layout';

export function WATCHER__image_edit_reset_field() {
  const dispatch = use_dispatch();

  const { g_general__layout, g_image_edit__field } = use_slice_ui(['g_general__layout', 'g_image_edit__field']);

  /*
   * EFFECTS
   */
  use_effect(() => {
    if (g_general__layout == ENUM__page_generation_layout.ASSETS) return; //no need to reset
    if (g_image_edit__field.is_stub()) return; //no need to reset

    dispatch(LOCAL__ui_set_field_for_generation_layout({ key: 'g_image_edit__field', field: FIELD__image_asset.CREATE_STUB() }));
  }, [g_general__layout]);

  return null;
}
